import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { MyEventServices } from 'src/app/services/my-event.service';
import { ProfileService } from 'src/app/services/profile.service';
import { VisitLog } from 'src/models/visitLog';

@Component({
  selector: 'app-profile-history',
  templateUrl: './profile-history.component.html',
  styleUrls: ['./profile-history.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule]
})
export class ProfileHistoryComponent implements OnInit, OnDestroy {
  @Input() profileId: number = 0;
  lstVisitLogs: VisitLog[] = [];
  newVisit: VisitLog;
  subscriptions: Subscription[] = [];

  constructor(private profileService: ProfileService, private myMessageService: MyEventServices, private userService: LoginService) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
    this.resetNewVisit();
    this.lstVisitLogs = [];

    this.subscriptions.push(this.profileService.getVisitLogs(this.profileId, 1).subscribe(result => {
      this.lstVisitLogs = result;
    }));
  }

  setLogDate(value: any) {
    if (value) {
      this.newVisit.VisitDate = new Date(value);
    }
  }

  setReminderDate(value: any) {
    if (value) {
      this.newVisit.ReminderDate = new Date(value);
    }
  }

  resetNewVisit() {
    this.newVisit = {} as VisitLog;
    this.newVisit.CreatedByName = this.userService.currentUser?.UserFullName;
    this.newVisit.CreatedBy = this.userService.currentUser?.UserId;
    this.newVisit.ProfileId = this.profileId;
  }

  saveVisit(visit: VisitLog) {
    if (this.isNewVisitValid(visit)) {
      this.subscriptions.push(this.profileService.insertVisitLog(visit).subscribe(result => {
        if (result) {
          if (visit.VisitId && visit.VisitId > 0) {
            visit.IsEditMode = false;
          }
          else {
            this.lstVisitLogs.splice(0, 0, visit);
            this.resetNewVisit();
          }

          this.myMessageService.showToast("success", "Saved", "Visit was saved");
        }
        else {
          this.myMessageService.showToast("error", "Not Saved", "Unable to save visit, try again.");
        }
      }));
    }
  }

  isNewVisitValid(visit: VisitLog) {
    if (!visit.Comment || visit.Comment.length < 1) {
      this.myMessageService.showToast("error", "Comment Missing", "Please enter a comment");
      return false;
    }
    else if (!visit.VisitDate || visit.VisitDate.toLocaleString().length < 1) {
      this.myMessageService.showToast("error", "Visit Date Missing", "Please enter visit date");
      return false;
    }
    else if (visit.VisitId == 0 &&
      this.lstVisitLogs?.filter(x => new Date(x.VisitDate).toLocaleDateString() == new Date(visit.VisitDate).toLocaleDateString()).length > 0) {
      this.myMessageService.showToast("error", "Duplicate Entries", "A visit was already registered on the select date");
      return false;
    }

    return true;
  }
}
